import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

const VideoLightbox = ({ src, onClose }) => {
  useEffect(() => {
    if (!src) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [src, onClose]);
  if (!src) return null;
  const close = (e) => { e.stopPropagation(); onClose(); };
  return createPortal(
    <div className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4" onClick={onClose} data-testid="video-lightbox-modal">
      <button className="fixed top-4 right-4 z-[110] w-12 h-12 rounded-full bg-white/15 backdrop-blur-md border border-white/40 text-white flex items-center justify-center active:scale-90 hover:bg-[#b4936a] transition-all" aria-label="Close video" data-testid="close-video-lightbox" onClick={close}>
        <X size={26} strokeWidth={1.6} />
      </button>
      <video key={src} className="max-h-[80vh] w-auto max-w-[92vw] rounded-xl shadow-2xl" controls autoPlay playsInline onClick={(e) => e.stopPropagation()}>
        <source src={src} type="video/mp4" />
      </video>
      <button className="absolute bottom-6 left-1/2 -translate-x-1/2 z-[110] text-[11px] tracking-luxe uppercase text-white/70 border border-white/25 rounded-full px-6 py-2.5 hover:text-white hover:border-white transition-all" onClick={close}>Close</button>
    </div>,
    document.body
  );
};

export default VideoLightbox;
